import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h1", null, "Ultimi Capitoli", -1)
const _hoisted_2 = { class: "album py-5 bg-light" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_6 = {
  key: 1,
  class: "row g-3"
}
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "row justify-content-md-center g-5" }
const _hoisted_9 = { class: "col-5" }
const _hoisted_10 = { class: "card-body col-7" }
const _hoisted_11 = {
  class: "card-title",
  style: {"font-weight":"bold","margin-right":"15px"}
}
const _hoisted_12 = { class: "table table-borderless" }
const _hoisted_13 = { style: {"text-align":"left"} }
const _hoisted_14 = { style: {"text-align":"right"} }
const _hoisted_15 = { class: "text-muted" }
const _hoisted_16 = /*#__PURE__*/_createVNode("td", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_NavBar),
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _hoisted_5
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_6, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (manga) => {
                return (_openBlock(), _createBlock("div", {
                  class: "col-12 col-lg-6",
                  key: manga
                }, [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", _hoisted_8, [
                      _createVNode("div", _hoisted_9, [
                        _createVNode(_component_router_link, {
                          to: '/manga/'+manga.manga.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode("img", {
                              src: manga.manga.cover,
                              class: "card-img-top",
                              style: {"object-fit":"cover","aspect-ratio":"12/17"}
                            }, null, 8, ["src"])
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createVNode("div", _hoisted_10, [
                        _createVNode(_component_router_link, {
                          to: '/manga/'+manga.manga.id,
                          style: {"text-decoration":"none","color":"black"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode("h4", _hoisted_11, _toDisplayString(manga.manga.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _createVNode("table", _hoisted_12, [
                          _createVNode("tbody", null, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(manga.chapters, (ch) => {
                              return (_openBlock(), _createBlock("tr", { key: ch }, [
                                _createVNode("th", _hoisted_13, [
                                  _createVNode(_component_router_link, {
                                    to: '/chapter/'+manga.manga.id+'/'+ch.chapter
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString((ch.volume&&_ctx.viewport>0 ? 'Vol.'+ch.volume+' ' : '') + 'Ch.'+ch.chapter) + _toDisplayString(ch.title&&_ctx.viewport>3 ? ' - '+ch.title : ''), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]),
                                _createVNode("td", _hoisted_14, [
                                  _createVNode("span", _hoisted_15, _toDisplayString(_ctx.$timeSince(new Date(parseInt(ch.time)))) + " fa", 1)
                                ]),
                                _hoisted_16
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ]))
      ])
    ])
  ]))
}